module.exports = __webpack_public_path__ + "media/images/interstitial/learn-0b1d1915fc0af835366c04a02ab12e77.svg";